import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';

const Layout = ({ children }) => {
    const location = useLocation();
    const scrollRef = useRef(null);

    // 페이지 변경 시 스크롤 초기화 (고강도)
    useEffect(() => {
        const resetScroll = () => {
            if (scrollRef.current) {
                scrollRef.current.scrollTop = 0;
                scrollRef.current.scrollTo(0, 0);
            }
            window.scrollTo(0, 0);
        };

        resetScroll();
        const timer = setTimeout(resetScroll, 10);
        return () => clearTimeout(timer);
    }, [location.pathname, location.search]);

    return (
        <div className="layout-container" style={{
            display: 'flex',
            width: '100%',
            maxWidth: '100vw',
            height: '100vh', /* 기본 호환성 유지 */
            overflow: 'hidden',
            background: 'radial-gradient(circle at center, #1e293b 0%, #0f172a 100%)',
            color: '#f8fafc'
        }}>
            <Sidebar />
            <main
                ref={scrollRef}
                id="main-scroll-container"
                className="main-content"
                style={{
                    flex: 1,
                    minWidth: 0,
                    width: '100%',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    position: 'relative',
                    paddingBottom: '80px',
                    padding: '0'
                }}
            >
                {children}
            </main>
            <MobileNav />
        </div>
    );
};

export default Layout;
